// icons
import { SvgCopyLink as CopyLink } from "assets/icons/js/SvgCopyLink";
import { SvgWhatsapp as Whatsapp } from "assets/icons/js/SvgWhatsapp";
// import { SvgEmailLink as EmailLink } from "assets/icons/js/SvgEmailLink";
// import { SvgSms as SmS } from "assets/icons/js/SvgSms";
// import { SvgFacebookLink as FacebookLink } from "assets/icons/js/SvgFacebookLink";
// import { SvgTwitter as Twitter } from "assets/icons/js/SvgTwitter";
// import { SvgPinterest as Pinterest } from "assets/icons/js/SvgPinterest";
// import { SvgMore as More } from "assets/icons/js/SvgMore";

export const shareLinkData = [
	{
		id: 1,
		icon: <CopyLink />,
		title: "Copy Link",
	},
	{
		id: 2,
		icon: <Whatsapp />,
		title: "Whatsapp",
	},
	// {
	// 	id: 3,
	// 	icon: <EmailLink />,
	// 	title: "Email",
	// },
	// {
	// 	id: 4,
	// 	icon: <SmS />,
	// 	title: "SMS",
	// },
	// {
	// 	id: 5,
	// 	icon: <FacebookLink />,
	// 	title: "Facebook",
	// },
	// {
	// 	id: 6,
	// 	icon: <Twitter />,
	// 	title: "Twitter",
	// },
	// {
	// 	id: 7,
	// 	icon: <Pinterest />,
	// 	title: "Pinterest",
	// },
	// {
	// 	id: 8,
	// 	icon: <More />,
	// 	title: "More",
	// },
];
